import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import { PathWithID } from '../../models/types';
import useMutation from '../useMutation';

import MutationKeys from './keys';

const useDeleteContentFolder = (folderId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_CONTENT_FOLDER,
        new PathWithID(CuredApiPaths.CONTENT_FOLDERS, folderId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteContentFolder;
